
export { default as NewGermanyCinema26 } from './impl/NewGermanyCinema26.jsx';


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/NewGermanyCinema26/index.jsx